import { Link, Outlet, useLocation } from 'react-router-dom';
import { Logo } from './Logo';
import { useAuth } from '../contexts/AuthContext';
import { UserMenu } from './UserMenu';

export function Layout() {
  const location = useLocation();
  const { user, loading } = useAuth();
  const isPricing = location.pathname === '/pricing';
  const isFullWidth =
    isPricing ||
    location.pathname === '/downloads' ||
    location.pathname.startsWith('/admin') ||
    location.pathname === '/account';

  return (
    <div className="bg-grid min-h-screen flex flex-col">
      <header className="fixed top-0 inset-x-0 z-50 backdrop-blur-xl bg-ll-bg/80 border-b border-ll-border">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-14 flex items-center justify-between">
          <Logo />
          <nav className="flex items-center gap-6">
            <Link
              to="/pricing"
              className="text-sm text-ll-muted hover:text-ll-text transition-colors"
            >
              Pricing
            </Link>
            <Link
              to="/downloads"
              className="text-sm text-ll-muted hover:text-ll-text transition-colors"
            >
              Downloads
            </Link>
            <a
              href="https://docs.layerlint.io"
              className="text-sm text-ll-muted hover:text-ll-text transition-colors"
            >
              Docs
            </a>
            {!loading &&
              (user ? (
                <UserMenu />
              ) : (
                <Link
                  to="/sign-in"
                  className="text-sm text-ll-cyan hover:brightness-110 transition-colors"
                >
                  Sign In
                </Link>
              ))}
          </nav>
        </div>
      </header>

      <main
        className={`flex-1 flex ${
          isFullWidth ? 'items-start' : 'items-center'
        } justify-center pt-14 min-h-screen`}
      >
        <Outlet />
      </main>

      <footer className="border-t border-ll-border py-8 px-4">
        <div className="max-w-7xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-ll-muted text-sm">
            &copy; {new Date().getFullYear()} LayerLint. All rights reserved.
          </p>
          <nav className="flex items-center gap-6">
            <a
              href="https://layerlint.ai/legal.html"
              className="text-sm text-ll-muted hover:text-ll-text transition-colors"
            >
              Privacy Policy
            </a>
            <a
              href="https://layerlint.ai/legal.html"
              className="text-sm text-ll-muted hover:text-ll-text transition-colors"
            >
              Terms of Service
            </a>
            <a
              href="https://docs.layerlint.io/security"
              className="text-sm text-ll-muted hover:text-ll-text transition-colors"
            >
              Security
            </a>
            <a
              href="mailto:hello@layerlint.com"
              className="text-sm text-ll-muted hover:text-ll-text transition-colors"
            >
              Contact
            </a>
          </nav>
        </div>
      </footer>
    </div>
  );
}
